import { API_ORIGIN } from '../config'
const API_BASE = `${API_ORIGIN}/api`

export async function getParkAlerts(parkId) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/alerts`)
  if (!response.ok) throw new Error('Error al obtener alertas')
  return response.json()
}

export async function dismissAlert(parkId, alertKey) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/alerts/${alertKey}/dismiss`, { method: 'POST' })
  if (!response.ok) throw new Error('Error al descartar la alerta')
  return response.json()
}